<template>
  <div class="info-box">
    <div class="info-box__header">
      <span class="info-box__icon">
        <img
          src="@/assets/scss/icons/triangle-exclamation-solid-full.svg"
          class="show-load-icon"
          alt="Warning icon"
        />
      </span>
      <strong>Important information</strong>
    </div>

    <p class="info-box__text">
      If your shipment includes more than one different UN number in the same pallet,
      <strong>please contact ltl@goglt.com.</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: 'HazmatInformationMessage',
};
</script>

<style lang="scss" scoped>
.info-box {
  background-color: rgba(232, 237, 255, 0.78);
  border: 1px solid #cfd9ff;
  padding: 0.75rem 1.25rem;
  border-radius: 10px;
  color: #0a3a52;                   /* Azul oscuro del texto */
  max-width: 100%;
  margin-top: 15px;

  text-align: start;
  font-style: italic;
  font-family: "Montserrat";
  text-align: left;
  font-size: 12px;
  &__header {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 6px;
    color: $color-primary-company;
  }
  &__icon {
    font-size: 12px;
  }
  &__text {
    margin: 0;
    font-size: 12px;
    color: $color-primary-company;
  }
  &__text strong {
    font-weight: 700;
  }
}
.show-load-icon{
  width: 15px;
}
</style>
